import { requestApi } from '@app/api';
import { withForm } from '@app/api/paths';

// eslint-disable-next-line import/prefer-default-export
export function getDraftsCountCreatedByForm(workspaceId: string) {
  return requestApi<{ count: number }>({
    url: withForm(`/workspaces/${workspaceId}/drafts/count-created-by-form`),
    method: 'GET',
    credentials: true,
  }).then((res) => res.data.count);
}
